import { useState } from 'react'
import { cn } from '@/lib/utils'
import BadgeTab from '@/components/feature/BadgeTab'
import TrophyTab from '@/components/feature/TrophyTab'

type Tab = 'trophy' | 'badge'

export default function TrophyPage() {
  const [activeTab, setActiveTab] = useState<Tab>('trophy')

  return (
    <div className="flex flex-col">
      <div className="flex border-b mb-4 -mx-4 px-4">
        <button
          onClick={() => setActiveTab('trophy')}
          className={cn(
            'flex-1 py-2 text-sm font-medium transition-colors',
            activeTab === 'trophy'
              ? 'border-b-2 border-primary text-primary'
              : 'text-muted-foreground',
          )}
        >
          トロフィー
        </button>
        <button
          onClick={() => setActiveTab('badge')}
          className={cn(
            'flex-1 py-2 text-sm font-medium transition-colors',
            activeTab === 'badge'
              ? 'border-b-2 border-primary text-primary'
              : 'text-muted-foreground',
          )}
        >
          オープンバッジ
        </button>
      </div>

      {activeTab === 'trophy' && <TrophyTab />}
      {activeTab === 'badge' && <BadgeTab />}
    </div>
  )
}
